const types = {
  SET_HISTORY: 'SET_HISTORY',
};

export default types;
